export default {
    ja: {
        credit: {
            type_1: {
                title: '主催',
                group1: {
                    name: 'Comrade',
                    src: 'Images/logo/comlade_logo.png',
                },
            },
            type_2: {
                title: '特別協力',
                group1: {
                    name: '那谷寺',
                    src: 'Images/logo/natadera_logo.png',
                },
            },
            type_3: {
                title: 'サポーティングパートナー',
                group1: {
                    name: '株式会社今出電気商会',
                },
                group2: {
                    name: 'ナカダ株式会社',
                },
                group3: {
                    name: '小松カントリークラブ',
                },
                group4: {
                    name: '東本電気株式会社',
                },
                group5: {
                    name: '日本料理梶助',
                },
                group6: {
                    name: '株式会社オン・ザ・コーナー',
                },
                group7: {
                    name: 'サンコロナ小田株式会社',
                },
                group8: {
                    name: '株式会社江口組',
                },
                group9: {
                    name: '株式会社ミュージッククラブ',
                },
                group10: {
                    name: 'あわづ温泉喜多八',
                },
                group11: {
                    name: '株式会社寺田鉄工建設',
                },
                group12: {
                    name: 'ツボ電気工事株式会社',
                },
                group13: {
                    name: '株式会社いーじー',
                },
                group14: {
                    name: '満点ノ 辻のや',
                },
            },
            type_4: {
                title: 'スペシャルパートナー',
                group1: {
                    name: '中山賢一',
                },
                group2: {
                    name: 'HULK',
                    src: 'Images/logo/logo_hulk.svg',
                },
                group3: {
                    name: '戸田組',
                    src: 'Images/logo/toda_logo.png',
                },
            },
            type_9: {
                title: 'スペシャルパートナー',
                group1: {
                    name: 'UEDA',
                    src: 'Images/logo/logo_ueda.webp',
                    alt: 'UEDA',
                },
                group2: {
                    name: '北陸ファイバーグラス株式会社',
                    src: 'Images/logo/logo_hokuriku-fiber.webp',
                    alt: '北陸ファイバーグラス株式会社',
                },
                group3: {
                    name: 'SEIKO GIKEN INC.',
                    src: 'Images/logo/logo_seiko-giken.webp',
                    alt: 'SEIKO GIKEN INC.',
                },
            },
            type_5: {
                title: 'オフィシャルパートナー',
                group1: {
                    name: '株式会社浦建築研究所',
                },
                group2: {
                    name: '金沢まいもん寿司',
                },
                group3: {
                    name: '株式会社トーケン',
                    src: 'Images/logo/token_logo.jpg',
                },
                group4: {
                    name: '兼六建設株式会社',
                    src: 'Images/logo/kenroku_logo.jpg',
                },
                group5: {
                    name: '株式会社中東',
                },
                group6: {
                    name: '三幸電設株式会社',
                },
                group7: {
                    name: 'はくれい幼稚園',
                    src: 'Images/logo/kamide_logo.jpg',
                },
                group8: {
                    name: '株式会社丸西組',
                },
                group9: {
                    name: '米沢電気工事株式会社',
                },
                group10: {
                    name: 'LGP lab',
                },
                group11: {
                    name: '市民セレクト株式会社',
                },
                group12: {
                    name: '小松ガス株式会社',
                },
                group13: {
                    name: '太陽工業株式会社',
                },
                group14: {
                    name: '有限会社プロジェクト・ガード・サービス',
                },
            },
            type_8: {
                title: 'アソシエイトパートナー',
                group1: {
                    name: 'ヨシダ自動車株式会社',
                },
                group2: {
                    name: '株式会社オオミ住装',
                },
                group3: {
                    name: '税理士法人しんあい三由会計事務所',
                },
                group4: {
                    name: 'スマイルレンタカー',
                },
                group5: {
                    name: '有限会社東洋カーショップ',
                },
                group6: {
                    name: '株式会社糸町',
                },
                group7: {
                    name: '株式会社ヒラシマ',
                },
                group8: {
                    name: '三洋自動車株式会社',
                },
                group9: {
                    name: '株式会社桶建材店',
                },
                group10: {
                    name: '株式会社山本建設',
                },
                group11: {
                    name: '株式会社吉光組',
                },
                group12: {
                    name: '大竹電機株式会社',
                },
                group13: {
                    name: 'こまつ自動車学校',
                },
                group14: {
                    name: '秀寿司',
                },
                group15: {
                    name: '有限会社任田リース',
                },
                group16: {
                    name: '協和金属工業株式会社',
                },
                group17: {
                    name: '西田商事株式会社',
                },
                group18: {
                    name: '焼肉ホルモン誠',
                },
                group19: {
                    name: '有限会社山本製材',
                },
                group20: {
                    name: '株式会社ヒロタ',
                },
                group21: {
                    name: '株式会社大川電気商会',
                },
                group22: {
                    name: '株式会社エステート・ワン',
                },
            },
            type_7: {
                title: '協力',
                group1: {
                    name: '株式会社オン・ザ・コーナー',
                },
                group2: {
                    name: '小松九谷工業協同組合',
                },
                group3: {
                    name: '石材荒谷商店',
                },
                group4: {
                    name: 'Nanaflower',
                },
            },
            type_6: {
                title: '後援',
                group1: {
                    name: '小松市',
                    src: 'Images/logo/komatsu-city_logo.png',
                },
                group2: {
                    name: '北國新聞社',
                },            
                group3: {
                    name: '一般社団法人こまつ観光物産ネットワーク',
                },            
          
            },
            project: {
                title: '企画・演出・制作',
                name: 'NAKED, INC. (株式会社ネイキッド)',
                caption: '1997年に設立されたクリエイティブカンパニー。映画をルーツに持つ強い物語性と世界観に、その時代ならではのテクノロジーを掛け合わせ、新たな体験を生み出している。代表作に、G7広島サミット 社交行事演出、『NAKED桜の新宿御苑』、シンガポール屈指の動物園マンダイ・ワイルドライフ・リザーブとのコラボイベント、『NAKED meets 二条城』、京都駅ビルから新たな文化発信を担う『庭プロジェクト』など。',
            },
            project2: {
                name: '',
                caption: 'ノエチカの『ノ』は能登（石川県北部）、『エチ』は越前（福井県）、越中（富山県）、『カ』は加賀（石川県南部）、金澤を示し、これらの地域において、文化芸術活動を通じた北陸地域の価値創造に寄与します。',
            },
            project3: {
                name: '',
                caption: '',
            },
        },
    },
    en: {
        credit: {
            type_1: {
                title: 'Hosted by',
                group1: {
                    name: 'Comrade',
                    src: 'Images/logo/comlade_logo.png',
                },
            },
            type_2: {
                title: 'In special cooperation with',
                group1: {
                    name: 'Natadera',
                    src: 'Images/logo/natadera_logo.png',
                },
            },
            type_3: {
                title: 'Supporting Partner',
                group1: {
                    name: 'Imade Electric Co., Ltd.',
                },
                group2: {
                    name: 'Nakada Co., Ltd.',
                },
                group3: {
                    name: 'Komatsu Country Club',
                },
                group4: {
                    name: 'Tohmoto Electric Co., Ltd.',
                },
                group5: {
                    name: 'Kaisuke Japanese Cuisine',
                },
                group6: {
                    name: 'On the Corner Co., Ltd.',
                },
                group7: {
                    name: 'Suncorona Oda Co., Ltd.',
                },
                group8: {
                    name: 'Eguchi Gumi Co., Ltd.',
                },
                group9: {
                    name: 'Music Club Co., Ltd.',
                },
                group10: {
                    name: 'Awazu Onsen Kitahachi',
                },
                group11: {
                    name: 'Terada Ironworks and Construction Co., Ltd.',
                },
                group12: {
                    name: 'Tsubo Electric Works Co., Ltd.',
                },
                group13: {
                    name: 'E.G. Co., Ltd.',
                },
                group14: {
                    name: 'Mantenno Tsujinoya',
                },
            },
            type_4: {
                title: 'Special partner',
                group1: {
                    name: 'Nakayama Kenichi',
                },
                group2: {
                    name: 'HULK',
                    src: 'Images/logo/logo_hulk.svg',
                },
                group3: {
                    name: 'Toda Corporation',
                    src: 'Images/logo/toda_logo.png',
                },
            },
            type_9: {
                title: 'Special partner',
                group1: {
                    name: 'UEDA',
                    src: 'Images/logo/logo_ueda.webp',
                    alt: 'UEDA',
                },
                group2: {
                    name: 'Hokuriku Fiber Glass Co Ltd.',
                    src: 'Images/logo/logo_hokuriku-fiber.webp',
                    alt: 'Hokuriku Fiber Glass Co Ltd.',
                },
                group3: {
                    name: 'SEIKO GIKEN INC.',
                    src: 'Images/logo/logo_seiko-giken.webp',
                    alt: 'SEIKO GIKEN INC.',
                },
            },
            type_5: {
                title: 'Official partner',
                group1: {
                    name: 'Ura Architects & Ura Environmental Architects Ltd.',
                },
                group2: {
                    name: 'Kanazawa Maimon Sushi',
                },
                group3: {
                    name: 'Token Corporation',
                    src: 'Images/logo/token_logo.jpg',
                },
                group4: {
                    name: 'KENROKU KENSETSU Co.,Ltd.',
                    src: 'Images/logo/kenroku_logo.jpg',
                },
                group5: {
                    name: 'Chuto Co., Ltd.',
                },
                group6: {
                    name: 'Sanko Electrical Construction Co., Ltd.',
                },
                group7: {
                    name: 'Hakurei Kindergarten',
                    src: 'Images/logo/kamide_logo.jpg',
                },
                group8: {
                    name: 'Marunishi-gumi Co., Ltd.',
                },
                group9: {
                    name: 'Yonezawa Electric Co., Ltd.',
                },
                group10: {
                    name: 'LGP lab',
                },
                group11: {
                    name: 'Citizen Select Co., Ltd',
                },
                group12: {
                    name: 'Komatsu Gas Co., Ltd.',
                },
                group13: {
                    name: 'Taiyo Kogyo Corporation',
                },
                group14: {
                    name: 'Project Guard Service Co., Ltd.',
                },
            },
            type_8: {
                title: 'Associate Partners',
                group1: {
                    name: 'Yoshida Motors Co., Ltd.',
                },
                group2: {
                    name: 'Oomi Jusou Co., Ltd.',
                },
                group3: {
                    name: 'Shinai Mitsuyu Tax Corporation',
                },
                group4: {
                    name: 'Smile Rent-a-Car',
                },
                group5: {
                    name: 'Toyo Car Shop Ltd.',
                },
                group6: {
                    name: 'Itomachi Co., Ltd.',
                },
                group7: {
                    name: 'Hirashima Co., Ltd.',
                },
                group8: {
                    name: 'Sanyo Motors Co., Ltd.',
                },
                group9: {
                    name: 'Okekan Zaiten Co., Ltd.',
                },
                group10: {
                    name: 'Yamamoto Construction Co., Ltd.',
                },
                group11: {
                    name: 'Yoshimitsu Gumi Co., Ltd.',
                },
                group12: {
                    name: 'Ohtake Electric Co., Ltd.',
                },
                group13: {
                    name: 'Komatsu Driving School',
                },
                group14: {
                    name: 'Hide Sushi',
                },
                group15: {
                    name: 'Ninda Lease Ltd.',
                },
                group16: {
                    name: 'Kyowa Metal Industry Co., Ltd.',
                },
                group17: {
                    name: 'Nishida Shoji Co., Ltd.',
                },
                group18: {
                    name: 'Yakiniku Hormone Makoto',
                },
                group19: {
                    name: 'Yamamoto Sawmill Ltd.',
                },
                group20: {
                    name: 'Hirota Co., Ltd.',
                },
                group21: {
                    name: 'Okawa Electric Company Co., Ltd.',
                },
                group22: {
                    name: 'Estate One Co., Ltd.',
                },
            },
            type_7: {
                title: 'cooperation with',
                group1: {
                    name: 'On the Corner Co., Ltd.',
                },
                group2: {
                    name: 'Komatsu Kutani Pottery Industrial Cooperative',
                },
                group3: {
                    name: 'Araya Stone Store',
                },
                group4: {
                    name: 'Nanaflower',
                },
            },
            type_6: {
                title: 'Supported by',
                group1: {
                    name: 'Komatsu City',
                    src: 'Images/logo/komatsu-city_logo.png',
                },
                group2: {
                    name: 'HOKKOKU SHIMBUN INC.',
                },            
                group6: {
                    name: 'Komatsu Tourism and Local Products Network Association',
                },
                group3: {
                    name: 'Komatsu Tourism and Local Products Network Association',
                },            
           
            },
            project: {
                title: 'Design, Direction, Production',
                name: 'NAKED, INC.',
                caption: 'NAKED, INC. is a creative company founded in 1997. With roots in filmmaking, the company combines compelling storytelling and immersive worldviews with cutting-edge technologies of each era to create new experiences. Notable works include the G7 Hiroshima Summit social event production, “Sakura Night Garden at Shinjuku Gyoen”, a collaborative event with Singapore\'s premier zoological garden Mandai Wildlife Reserve, “NAKED meets Nijo-jo Castle”, and “NIWA PROJECT”, a new cultural initiative at Kyoto Station.',
            },
            project2: {
                name: '',
                caption: '',
            },
            project3: {
                name: '',
                caption: '',
            },
        },
    },

}